// src/components/reader/AskAiFab.jsx
//
// The floating "Ask AI" button (reader-ai-fab). The reader header's Ask AI pill is the
// only other entry point and the header is not sticky, so once a student scrolls into
// a lesson the way to ask a question is off screen. This one stays put.
//
// Scope: open the existing AI drawer, nothing else -- no state, no data, no AI call.
// Geometry (position, the clearance above the mobile bottom bar, z-index) lives in
// lesson.css as .btl-ai-fab, next to the bar's own rules, so the two cannot drift.
//
// FILLED, not outlined like the header pill: a floating button is the page's primary
// action and has to read as one from across the page; --accent fill with --accent-ink
// is the token pair for exactly that. Circular and icon-only at every width, with an accessible label.
// Real <button>, 44px target and the site-wide focus ring.
import React from 'react';
import ReadingTools from './ReadingTools.jsx';
import { IconSparkles } from '../icons.jsx';
import './lesson.css';

export default function AskAiFab({ onClick, packId, itemId }) {
    return (
        <>
        {packId && itemId && <ReadingTools key={packId + itemId} packId={packId} itemId={itemId} />}
        <button type="button" onClick={onClick} aria-label="Ask the AI Study Partner" title="Ask the AI Study Partner"
            className="btl-ai-fab flex items-center justify-center gap-1.5 font-display text-sm font-semibold">
            <IconSparkles className="w-5 h-5 flex-shrink-0" />
            <span className="sr-only">Ask AI</span>
        </button>
        </>
    );
}
